import React from 'react';

export function Table({ children, className = '' }) {
  return (
    <div className={`ds-table-wrap ${className}`.trim()}>
      <table className="ds-table">{children}</table>
    </div>
  );
}

export function TableHead({ children }) {
  return <thead className="ds-table__head">{children}</thead>;
}

export function TableBody({ children }) {
  return <tbody className="ds-table__body">{children}</tbody>;
}

export function TableRow({ children, onClick, className = '' }) {
  return (
    <tr
      className={`ds-table__row${onClick ? ' ds-table__row--clickable' : ''} ${className}`.trim()}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </tr>
  );
}

export function TableCell({ children, header = false, className = '', colSpan }) {
  const Tag = header ? 'th' : 'td';
  return (
    <Tag
      className={`ds-table__cell${header ? ' ds-table__cell--head' : ''} ${className}`.trim()}
      colSpan={colSpan}
    >
      {children}
    </Tag>
  );
}

export default Table;
